import { Routes, Route } from 'react-router-dom';
import "./assets/css/General/fontStyle.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./App.css";
// General//
import Notfound from './screens/General/Notfound';
import AccountSelection from './screens/General/AccountSelection';
//Admin//
import AdminLogin from './screens/Admin/AdminAuth/AdminLogin';
import Adminforgotpassword from './screens/Admin/AdminAuth/Adminforgotpassword';
import Adminotpverification from './screens/Admin/AdminAuth/Adminotpverification';
import Adminresetpassword from './screens/Admin/AdminAuth/Adminresetpassword';
import AdminDashboard from './screens/Admin/AdminDashboard/AdminDashboard';
import AllCustomers from './screens/Admin/AllCustomers/AllCustomer';
import AllDrivers from './screens/Admin/AllDrivers/AllDriver';
import AdminInstallments from './screens/Admin/installments/AdminInstallments';
import SubAdmin from './screens/Admin/SubAdmin/SubAdmin';
import OngoingOrders from './screens/Admin/OngoingOrders/OngoingOrders';
import CompletedOrders from './screens/Admin/CompletedOrders/CompletedOrders';
import CancelledOrders from './screens/Admin/CancelledOrders/CancelledOrders';
import HelpSupport from './screens/Admin/HelpSupport/HelpSupport';
import Earnings from './screens/Admin/Earnings/Earnings';
import Notifications from './screens/Admin/Notifications/Notifications';
import AdminProfile from './screens/Admin/AdminProfile/AdminProfile';


//customer//

import CustomerLogin from './screens/Customer/CustomerAuth/CustomerLogin';
import CustomerOtpVerification from './screens/Customer/CustomerAuth/CustomerOtpVerification';
import CustomerSignup from './screens/Customer/CustomerAuth/CustomerSignup';
import CustomerForgotPassword from './screens/Customer/CustomerAuth/CustomerForgotPassword';
import CustomerResetPassword from './screens/Customer/CustomerAuth/CustomerResetPassword';
import CustomerDashboard from './screens/Customer/CustomerDashboard/CustomerDashboard';
import CustomerInstantRide from './screens/Customer/CustomerDashboard/CustomerInstantRide';
import CustomerRideSelection from './screens/Customer/CustomerDashboard/CustomerRideSelection';
import CustomerFindingDriver from './screens/Customer/CustomerDashboard/CustomerFindingDriver';
import CustomerSetting from './screens/Customer/CustomerSettings/CustomerSetting';
import NotificationList from './screens/Customer/Notification/NotificationList';
import CustomerProfileSetting from './screens/Customer/CustomerSettings/CustomerProfileSetting';
import CustomerRideDetails from './screens/Customer/CustomerSettings/CustomerRideDetails';
import CustomerAppSetting from './screens/Customer/CustomerSettings/CustomerAppSetting';
import CustomerScanner from './screens/Customer/CustomerSettings/CustomerScanner';
import CustomerCategories from "./screens/Customer/CustomerCategories/CustomerCategories";
import CustomerSecurity from "./screens/Customer/CustomerSettings/CustomerSecurity";
import CustomerHelpCenter from "./screens/Customer/CustomerSettings/CustomerHelpCenter";
import CustomerCoinWallet from "./screens/Customer/CustomerSettings/CustomerCoinWallet";
import CustomerMyRide from "./screens/Customer/CustomerMyRide/CustomerMyRide";
import CustomerChat from "./screens/Customer/CustomerChat/CustomerChat";
import VoiceBooking from "./screens/Customer/voicebooking/VoiceBooking";
import CustomerAcceptRide from './screens/Customer/CustomerDashboard/CustomerAcceptRide';
import CustomerDateTimeSchedule from './screens/Customer/CustomerDashboard/CustomerDateTimeSchedule';
import CustomerRating from './screens/Customer/CustomerDashboard/CustomerRating';



///*driver*//
import DriverLogin from './screens/Drivers/DriverAuth/DriverLogin';
import IdentityVerification from './screens/Drivers/DriverKyc/IdentityVerification';
import VehicleUpload from './screens/Drivers/DriverKyc/VehicleUpload';
import Driversignup from './screens/Drivers/DriverAuth/Driversignup';
import DriverOtpVerification from './screens/Drivers/DriverAuth/DriverOtpVerification';
import DriverResetPassword from './screens/Drivers/DriverAuth/DriverResetPassword';
import VerifyDocuments from './screens/Drivers/DriverAuth/verifydocuments';
import DriverForgotPassword from './screens/Drivers/DriverAuth/DriverForgotPassword';
import DriverDashboard from './screens/Drivers/DriverDashboard/DriverDashboard';
import DriverActiveRides from './screens/Drivers/DriverActiveRides/DriverActiveRides';
import RideCompleted from './screens/Drivers/DriverActiveRides/RideCompleted';
import PickupCustomer from './screens/Drivers/DriverActiveRides/PickupCustomer';
import RideOnWay from './screens/Drivers/DriverActiveRides/RideOnWay';
import DriverMyRides from './screens/Drivers/DriverMyRides/DriverMyRides';
import DriverSetting from './screens/Drivers/DriverSetting/DriverSetting';
import DriverProfileSetting from './screens/Drivers/DriverSetting/DriverProfileSetting';
import DriverNotification from './screens/Drivers/DriverSetting/DriverNotification';
import DriverMyWallet from './screens/Drivers/DriverSetting/DriverMyWallet';
import DriverOfferList from './screens/Drivers/DriverSetting/DriverOfferList';
import DriverCreateOffer from './screens/Drivers/DriverSetting/DriverCreateOffer';
import DriverDocumentRegistration from './screens/Drivers/DriverSetting/DriverDocumentRegistration';
import DriverHelpCenter from './screens/Drivers/DriverSetting/DriverHelpCenter';
import DriverSecurity from './screens/Drivers/DriverSetting/DriverSecurity';
import Driverchat from './screens/Drivers/Driverchat/Driverchat';
import DriverTopup from './screens/Drivers/DriverSetting/DriverTopup';
import DriverQRcode from './screens/Drivers/DriverSetting/DriverQRcode';
import DriverNotificationList from './screens/Drivers/DriverNotification//DriverNotificationList';




function App() {
  return (
    <Routes>
      {/* general */}
      <Route path="*" element={<Notfound />} />
      <Route path="/" element={<AccountSelection />} />
      {/* //Admin/ */}
      <Route path="/admin-login" element={<AdminLogin />} />
      <Route path="/admin-forgot-password" element={<Adminforgotpassword />} />
      <Route path="/admin-reset-password" element={<Adminresetpassword />} />
      <Route path="/admin-otp-verification" element={<Adminotpverification />} />
      <Route path="/admin-dashboard" element={<AdminDashboard />} />
      <Route path="admin/all-customers" element={<AllCustomers />} />
      <Route path="admin/all-drivers" element={<AllDrivers />} />
      <Route path="admin/installment" element={<AdminInstallments />} />
      <Route path="admin/sub-admin" element={<SubAdmin />} />
      <Route path="admin/ongoing-orders" element={<OngoingOrders />} />
      <Route path="admin/completed-orders" element={<CompletedOrders />} />
      <Route path="admin/cancelled-orders" element={<CancelledOrders />} />
      <Route path="admin/help-support" element={<HelpSupport />} />
      <Route path="admin/earnings" element={<Earnings />} />
      <Route path="admin/notifications" element={<Notifications />} />
      <Route path="admin/profile" element={<AdminProfile />} />


      {/* //customer/ */}
      <Route path="/customer-login" element={<CustomerLogin />} />
      <Route path="/customer-otp-verification" element={<CustomerOtpVerification />} />
      <Route path="/customer-signup" element={<CustomerSignup />} />
      <Route path="/customer-login" element={<CustomerLogin />} />
      <Route path="/customer-forgot-password" element={<CustomerForgotPassword />} />
      <Route path="/customer-reset-password" element={<CustomerResetPassword />} />
      <Route path="/customer-dashboard" element={< CustomerDashboard />} />
      <Route path="/customer-setting" element={< CustomerSetting />} />
      <Route path="/customer-profile-setting" element={< CustomerProfileSetting />} />
      <Route path="/customer-app-setting" element={< CustomerAppSetting />} />
      <Route path="/customer-categories" element={< CustomerCategories />} />
      <Route path="/customer-security" element={< CustomerSecurity />} />
      <Route path="/customer-help-center" element={< CustomerHelpCenter />} />
      <Route path="/customer-coin-wallet" element={< CustomerCoinWallet />} />
      <Route path="/customer-myride" element={< CustomerMyRide />} />
      <Route path="/customer-instant-ride" element={< CustomerInstantRide />} />
      <Route path="/customer-ride-selection" element={< CustomerRideSelection />} />
      <Route path="/customer-finding-driver" element={<CustomerFindingDriver />} />
      <Route path="/customer-chat" element={<CustomerChat />} />
      <Route path="/voice-booking" element={<VoiceBooking />} />
      <Route path="/customer-accept-ride" element={<CustomerAcceptRide />} />
      <Route path="/Customerdate-time-schedule" element={<CustomerDateTimeSchedule />} />
      <Route path="/Customer-rating" element={<CustomerRating />} />
      <Route path="/Customer-scanner" element={<CustomerScanner />} />
      <Route path="/Customer-ride-details" element={<CustomerRideDetails />} />
      <Route path="/customer-notifications" element={<NotificationList />} />


      {/* ///Driver/// */}
      <Route path="/driver-login" element={<DriverLogin />} />
      <Route path="/identity-verification" element={<IdentityVerification />} />
      <Route path="/vehicle-upload" element={<VehicleUpload />} />
      <Route path="/driver-forgot-password" element={<DriverForgotPassword />} />
      <Route path="/driver-signup" element={<Driversignup />} />
      <Route path="/driver-otp-verification" element={<DriverOtpVerification />} />
       <Route path="/driver-reset-password" element={<DriverResetPassword />} />
      <Route path="/driver-verifydocument" element={<VerifyDocuments />} />
      <Route path="/driver-dashboard" element={<DriverDashboard />} />
      <Route path="/driver-active-rides" element={<DriverActiveRides />} />
      <Route path="/ride-completed" element={<RideCompleted />} />
      <Route path="/pickup-customer" element={<PickupCustomer />} />
      <Route path="/ride-onway" element={<RideOnWay />} />
      <Route path="/driver-chat" element={<Driverchat />} />
      <Route path="/driver-myrides" element={<DriverMyRides />} />
      <Route path="/driver-setting" element={<DriverSetting />} />
      <Route path="/driver-profile-setting" element={<DriverProfileSetting />} />
      <Route path="/driver-mywallet" element={<DriverMyWallet />} />
      <Route path="/driver-offerlist" element={<DriverOfferList />} />
      <Route path="/driver-createoffer" element={<DriverCreateOffer />} />
      <Route path="/driver-document-registration" element={<DriverDocumentRegistration />} />
      <Route path="/driver-help-center" element={<DriverHelpCenter />} />
      <Route path="/driver-security" element={<DriverSecurity />} />
      <Route path="/driver-notification-list" element={<DriverNotificationList />} />
       <Route path="/driver-notification" element={<DriverNotification />} />
      <Route path="/driver/topup" element={<DriverTopup />} />
      <Route path="/driver/qrcode" element={<DriverQRcode />} />

    </Routes>
  );
}

export default App;
